module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[107]472.2c8f45a.woff2";